











































import Vue from 'vue'
import Component from "vue-class-component";
import { Prop, Ref } from 'vue-property-decorator';
import {Action} from "vuex-class";
import { getErrorMessage } from '@/utils/notify-helper';

@Component
export default class registrationForm extends Vue {
  @Ref('validator') validator:any;
  @Prop() email!: string;

  @Action("regEntityCreate") actionRequest: any;
  @Action("authRequest") authRequest: any;
  @Action("getAllowedPages") actionGetAllowedPages: any;

  private form = {
    username: '',
    password: '',
  }

  async submit() {
    this.$emit('errorMessage', undefined)
    if (!await this.validator.validate()) {
      return
    }
    this.$emit('isProgress', true)
    try {
      const resp = await this.actionRequest({...this.form, email: this.email});
      setTimeout(async () => {
        const authResp = await this.authRequest(this.form)
        let allowedPages = await this.actionGetAllowedPages()
        localStorage.setItem('lk-allowedPages', JSON.stringify(allowedPages))
        this.$router.push('/')
      }, 1000)
      // this.$emit('form', 'loginForm')
    } catch (e) {
      // const errorMessage = getErrorMessage(e)
      this.$emit('errorMessage', this.$t('errors.registration_error'))
    } finally {
      this.$emit('isProgress', false)
    }
  }

}
